module.exports = __webpack_public_path__ + "static/img/indexICON71.f336ea6a.png";